import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { theme } from '@components/Provider';

export const HomeComponentContainer = styled(Box)`
  ${(props) => `
  padding : ${props.padding ? props.padding : '240px 0px'};
  display : flex;
  flex-direction : ${props.flexDirection ? props.flexDirection : 'column'};
  justify-content : center;
  align-items : center;
  > div {
    width : 960px;
  };
  ${theme.breakpoints.down('md')} {
    padding : ${props.padding ? props.padding : '240px 36px'};
    > div {
      width : 960px;
      padding-left : 36px;
      padding-right: 36px;
      position: relative;
    }
  };
  ${theme.breakpoints.down('sm')} {
    padding : ${props.padding ? props.padding : '120px 16px'};
    > div {
      width : 100%;
      padding-left : 0px;
      padding-right: 0px;
    }
  }
`}
`;
